import React, { useEffect } from "react";
import moment from 'moment';
import { formatDate } from '../../../utils/commonFunctions';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

interface Props {
    data: any;
    tableHeader: any;
    editEntry?: Function;
    // deleteEntry: (params: any) => void ;
    download?: Function;
    history?: any;
    activeTab?: string;
    handleSendOpenItemEmail?: (id: number) => void;
    isEditOpenItemPresent?:boolean;
    isViewOpenItemPresent?:boolean
}
class TableData extends React.Component<Props> {

    handleRedirect = (jobId: any) => {
        this.props.history.push({
            pathname: '/open-items-admin/summary/' + jobId,
            state: { currentTab: this.props.activeTab }
        });
    }

    handleEdit = (jobId: any) => {
        this.props.history.push({
            pathname: '/open-items-admin/edit/' + jobId,
            state: { currentTab: this.props.activeTab }
        });
    }

    getStatusClass = (status: number) => {
        switch (status) {
            case 0:
                return 'pending';
            case 1:
                return 'incomplete';
            case 2:
                return 'approval-pending';
            case 3:
                return 'complete';
            default:
                return;
        }
    }

    renderSendEmailToolTip = (props: any) => {
        return (
            <Tooltip id={`button-send-email`}{...props}>
                Send Email
            </Tooltip>
        )
    }

    renderViewOpenItemToolTip = (props: any) => {
        return (
            <Tooltip id="button-view-open-item" {...props}>
                View Open Item
            </Tooltip>
        )
    }

    renderEditOpenItemToolTip = (props: any) => {
        return (
            <Tooltip id="button-view-open-item" {...props}>
                Edit Open Item
            </Tooltip>
        )
    }

    renderSummaryTooltip = (props: any, data: any) => {
        return (
            <Tooltip id="button-view-open-item" {...props}>
                {data}
            </Tooltip>
        )
    }

    render() {
        const {
            data,
            tableHeader,
            editEntry,
            // deleteEntry,
            download,
            activeTab,
            handleSendOpenItemEmail,
            isEditOpenItemPresent,
            isViewOpenItemPresent
        } = this.props



        return data.map((dataItem: any, index: number) => {
            // let finalDate = dataItem.date_of_invoice ? moment(dataItem.date_of_invoice).format('DD-MM-YYYY') : dataItem.date ? moment(dataItem.date).format('DD-MM-YYYY') : '';

            let finalDate = dataItem?.date_modified ? formatDate(dataItem?.date_modified) : '';
            let finalSummary = dataItem?.summary?.length > 20 ? `${ dataItem?.summary?.slice(0, 10) }...` : dataItem?.summary;

            let status: string;
            if (dataItem?.status_code === 0) status = 'Pending'
            if (dataItem?.status_code === 1) status = 'Incomplete'
            if (dataItem?.status_code === 2) status = 'Approval Pending'
            if (dataItem?.status_code === 3) status = 'Complete'
            if (dataItem) {
                return (
                    <tr key={index}>
                        {
                            tableHeader.map((item: any, i: number) => {
                                if (item.value === 'finalDate') {
                                    return <td>{finalDate}</td>
                                }
                                else if (item.value === 'summary') {
                                    return <>
                                        <OverlayTrigger
                                            placement="top"
                                            delay={{ show: 250, hide: 250 }}
                                            overlay={this.renderSummaryTooltip('', dataItem?.summary)}
                                        >
                                            <td>{finalSummary}</td>
                                        </OverlayTrigger>
                                    </>
                                }
                                else if (item.value === 'job_end_date') {
                                    return <td style={{ width: '100px' }}>{formatDate(dataItem?.job_end_date)}</td>
                                }
                                else if (item.value === 'first_due_date') {
                                    return <td style={{ width: '100px' }}>{formatDate(dataItem?.first_due_date)}</td>
                                }
                                else if (item.value === 'modified_by') {
                                    return <td style={{ width: '100px' }}>
                                        {
                                            <>
                                             <div>{dataItem.first_name + " " +dataItem.last_name }</div>
                                             <div className="mt-1">{moment.utc(dataItem?.date_modified).local().format('DD-MM-YY, h:mm a')}</div>
                                            </>
                                        }</td>
                                }
                                else if (item.value === 'job_type') {
                                    return <td>
                                        <div> {dataItem[item.value]} </div>
                                        <label> {dataItem.job_id} </label>
                                    </td>

                                }
                                else if (item.value === 'status_code') {
                                    return <td style={{ width: '100px' }}>
                                        <p className={`status-${ this.getStatusClass(dataItem?.status_code) } text-center`}>
                                            {status ? status : 'Pending'}
                                        </p>
                                    </td>
                                }
                                else if (dataItem[item.value]) {
                                    return <td> {dataItem[item.value]}</td>
                                }
                                else {
                                    return <td> --/-- </td>
                                }

                            })
                        }
                        {/* <td className="text-right">
                            <ul className="list-group list-group-horizontal action-list float-right">
                                {dataItem['file_url'] ? <li>
                                    <a
                                        className="dropdown-toggle btn btn-outline-secondary mr-2"
                                        href={blobBaseUrl + dataItem['file_url'] + '?' + blobToken}
                                        style={{padding:'4px 7px'}}
                                    >
                                        <DownloadIcon />
                                      
                                    </a>

                                    <a className="pointer" onClick={()=>deleteEntry(dataItem['document_id'])}>
                                        <img src='/img/icons/IconDelete.svg' />
                                    </a>
                                </li> : null}

                            </ul>
                        </td> */}
                        <td style={{ width: '100px' }}>

                            <div className="d-flex justify-content-start align-items-center">
                                { isEditOpenItemPresent && <OverlayTrigger
                                    placement="top"
                                    delay={{ show: 250, hide: 250 }}
                                    overlay={this.renderEditOpenItemToolTip}
                                >
                                    <span className="d-inline-block pointer" onClick={() => this.handleEdit(dataItem.open_item_id)}> <img src="/img/icons/IconEdit.svg" /> </span>
                                </OverlayTrigger>}
                                {isViewOpenItemPresent && <OverlayTrigger
                                    placement="top"
                                    delay={{ show: 250, hide: 250 }}
                                    overlay={this.renderViewOpenItemToolTip}
                                >
                                    <span className="d-inline-block pointer" onClick={() => this.handleRedirect(dataItem.open_item_id)}>
                                        <span
                                            className="las la-eye"
                                            style={{
                                                fontSize: '20px',
                                                color: '#484848',
                                                background: 'rgb(253 245 244)',
                                                padding: '8px',
                                                margin: '0px 0 0 3px',
                                                verticalAlign: 'middle'
                                            }}
                                        >
                                        </span>
                                    </span>
                                </OverlayTrigger>}
                                
                                
                                {dataItem?.status_code == 0 || dataItem?.status_code == 1 ? <OverlayTrigger
                                    placement="top"
                                    delay={{ show: 250, hide: 250 }}
                                    overlay={this.renderSendEmailToolTip}
                                >
                                    <span className="d-inline-block pointer" onClick={() => this.props.handleSendOpenItemEmail?.(dataItem.open_item_id)}>
                                        <span
                                            className="las la-envelope-open-text"
                                            style={{
                                                fontSize: '20px',
                                                color: '#484848',
                                                background: 'rgb(253 245 244)',
                                                padding: '8px',
                                                margin: '0px 0 0 3px',
                                                verticalAlign: 'middle'
                                            }}
                                        >
                                        </span>
                                    </span>
                                </OverlayTrigger> : null}
                                
                                
                            </div>
                        </td>
                    </tr>
                )
            }
        })
    }
}

export default TableData;